import { Injectable } from '@angular/core';

@Injectable()
export class QuickProfileService {
  counter: number = 0;
  timer: number = -1;

  reset(): any {
    this.counter = 0;
    this.timer = -1;
  }

  checkPoint(tag?: string) {
    let now = window.performance.now();
    if (this.timer < 0) {
      this.timer = now;
      return;
    }
    
    console.log(`${this.counter} ${tag || ''} : ${now - this.timer}`);
    this.timer = now;
    this.counter++;
  }
}
